/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloClasificaciones from 'Infotrack@Modelos/smartStock/clasificaciones';
import IClasificaciones from 'Infotrack@Modelos/smartStock/clasificaciones/entidades/clasificaciones';
import IFiltrosClasificaciones from 'Infotrack@Modelos/smartStock/clasificaciones/entidades/filtrosClasificaciones';

export default class ControladorModeloClasificaciones {
    private modeloClasificaciones: ModeloClasificaciones;
    constructor() {
        this.modeloClasificaciones = new ModeloClasificaciones();
    }

    public consultarClasificaciones() {
        return this.modeloClasificaciones.consultarClasificaciones().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearClasificaciones(clasificaciones: IClasificaciones) {
        await this.modeloClasificaciones.crearClasificaciones(clasificaciones);
    }

    public async editarClasificaciones(clasificaciones: IClasificaciones) {
        await this.modeloClasificaciones.editarClasificaciones(clasificaciones);
    }
    public async eliminarClasificaciones(clasificaciones: IClasificaciones) {
        await this.modeloClasificaciones.eliminarClasificaciones(clasificaciones);
    }

    public validarEntidad(clasificaciones: IClasificaciones): boolean {
        if (clasificaciones.ClasificacionDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarClasificacionesPorFiltro(filtrosClasificaciones: IFiltrosClasificaciones) {
        return (await this.modeloClasificaciones.consultarListaClasificacionesPorFiltro(filtrosClasificaciones)).data.Entidades;
    }
}
